module.exports = __webpack_public_path__ + "static/media/warnicon.1662ee14.png";